export const DATE_WISE_TRANSACTION_REPORT_REQUEST = 'DATE_WISE_TRANSACTION_REPORT_REQUEST';
export const DATE_WISE_TRANSACTION_REPORT_SUCCESS = 'DATE_WISE_TRANSACTION_REPORT_SUCCESS';
export const DATE_WISE_TRANSACTION_REPORT_FAILURE = 'DATE_WISE_TRANSACTION_REPORT_FAILURE';